import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { array, func } from 'prop-types';
import Option from './option';
import { useMergeCssClasses } from '../../../../Utils/utils';
import defaultClasses from './option.module.css';
import { useOptions } from '@magento/peregrine/lib/talons/ProductOptions/useOptions';
import { InfoIcon } from '../ProductFullDetail/Icons';
import { ActiveInfoIcon } from '../../../../components';

var Options = function Options(props) {
  var propClasses = props.classes,
      onSelectionChange = props.onSelectionChange,
      options = props.options,
      _props$selectedValues = props.selectedValues,
      selectedValues = _props$selectedValues === void 0 ? [] : _props$selectedValues,
      defaultOptionSelection = props.defaultOptionSelection,
      disabledValuesMap = props.disabledValuesMap,
      isReset = props.isReset;
  var classes = useMergeCssClasses(defaultClasses, propClasses);
  var talonProps = useOptions({
    onSelectionChange: onSelectionChange,
    selectedValues: selectedValues
  });
  var handleSelectionChange = talonProps.handleSelectionChange,
      selectedValueMap = talonProps.selectedValueMap; // Render a list of options passing in any pre-selected values.

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement("h5", {
    className: classes.optionsTitle
  }, "Selected Options"), React.createElement("div", {
    className: defaultClasses.infoIcon
  }, React.createElement("div", {
    className: defaultClasses.informationMsg
  }, React.createElement("div", {
    className: defaultClasses.arrowInfoWrapper
  }, React.createElement("p", {
    className: "py-7 px-4"
  }, "Image shown may not ", React.createElement("br", null), " correspond to selected options"))))), React.createElement("div", {
    className: "grid grid-cols-2 gap-8 xl_gap-10 "
  }, options.filter(function (item) {
    return !(item.values.length < 2 && ['hf_lamping', 'hf_pipe_length'].includes(item === null || item === void 0 ? void 0 : item.attribute_code));
  }).map(function (option) {
    return React.createElement(Option, _extends({}, option, {
      classes: classes,
      key: option.attribute_id,
      onSelectionChange: handleSelectionChange,
      selectedValue: option.values.find(function (value) {
        return value.value_index == selectedValues.get(option.attribute_id);
      }),
      defaultOptionValue: defaultOptionSelection.get(option.attribute_id),
      disabledValuesMap: disabledValuesMap.get(option.attribute_id),
      isReset: isReset
    }));
  })));
};

Options.propTypes = {
  onSelectionChange: func,
  options: array.isRequired
};
export default Options;